import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThunkExternalLogin, ThunkLogin, ThunkMfaLogin } from 'store/authorization/thunks';
import { REFRESH_TOKEN, TOKEN, USER_ID } from 'constants/localStorage';
import { ILoginResponse } from 'store/user/types';

const authorizationSlice = createSlice({
  name: 'authorization',
  initialState: {},
  reducers: {
    setUserData: (state, action: PayloadAction<ILoginResponse>) => {
      localStorage.setItem(TOKEN, action.payload.accessToken);
      localStorage.setItem(REFRESH_TOKEN, action.payload.refreshToken);
      localStorage.setItem(USER_ID, action.payload.userId);
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(ThunkLogin.fulfilled, (state, action) => {
      localStorage.setItem(TOKEN, action.payload.accessToken);
      localStorage.setItem(REFRESH_TOKEN, action.payload.refreshToken);
      localStorage.setItem(USER_ID, action.payload.userId);
    });

    builder.addCase(ThunkMfaLogin.fulfilled, (state, action) => {
      localStorage.setItem(TOKEN, action.payload.accessToken);
      localStorage.setItem(REFRESH_TOKEN, action.payload.refreshToken);
      localStorage.setItem(USER_ID, action.payload.userId);
    });

    builder.addCase(ThunkExternalLogin.fulfilled, (state, action) => {
      localStorage.setItem(TOKEN, action.payload.accessToken);
      localStorage.setItem(REFRESH_TOKEN, action.payload.refreshToken);
      localStorage.setItem(USER_ID, action.payload.userId);
    });
  },
});

export default authorizationSlice.reducer;

export const { setUserData } = authorizationSlice.actions;
